<template>
  <div class="pg-dialog-select-icon">
    <i class="pg-dialog-select-icon_val" :class="value"></i>
    <Button type="primary" circle @click="showDrawer = true">
      <i class="ivu-icon-icon-pg-serach"></i>
    </Button>
    <Button type="text" style="margin-left: 0" @click="onClear">清空</Button>
    <Dialog
      custom-class="pg-dialog pg-dialog-select-icon-dialog"
      top=""
      :title="title"
      :visible="showDrawer"
      :modal="modal"
      :before-close="onCancel"
      :append-to-body="appendToBody"
      :width="width"
      @close="close"
      @closed="closed"
      @open="open"
    >
      <div class="pg-dialog-select-icon__content">
        <div class="pg-dialog-select-icon__content_top">
          <PgInput
            prefix-icon="el-icon-search"
            clearable
            v-model="keyword"
            placeholder="请输入图标名称"
          />
          <PgSelect :source="typeList" v-model="type" :value-is-obj="false" @change="typeChange" />
        </div>
        <div class="pg-dialog-select-icon__content_list">
          <div
            class="pg-dialog-select-icon__content_list_item"
            :class="{ active: iconfontList.css_prefix_text + item.font_class === data }"
            v-for="item in searchIconList"
            :key="item.icon_id"
            @click="select(item)"
          >
            <i :class="iconfontList.css_prefix_text + item.font_class"></i>
            <span>{{ item.name }}</span>
            <span class="pg-dialog-select-icon__content_list_item-copy" @click.stop="copy(item)"
              >复制样式</span
            >
          </div>
        </div>
      </div>
      <template #footer>
        <slot name="footer">
          <Button class="pg-dialog-select-icon__btn" round @click="handleCancel">取消</Button>
          <Button class="pg-dialog-select-icon__btn" type="primary" round @click="handleOk"
            >确定</Button
          >
        </slot>
      </template>
    </Dialog>
  </div>
</template>
<script setup>
import { Dialog, Button } from 'element-ui'
import { useDrawerPack } from '../../../hooks/index'
import { PgInput } from '../../input/index'
import { PgSelect } from '../../select/index'
import { pgMessage } from '../../message/index'
import { toRef, shallowRef, ref, computed } from 'vue'
import pgIcons from '../../../styles/fonts_pg16/iconfont.json'
import omgIcons from '../../../styles/fonts_omg/iconfont.json'
import yjIcons from '../../../styles/fonts_yj/iconfont.json'

const props = defineProps({
  title: {
    type: String,
    default: '请选择',
  },
  visible: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: '80%',
  },
  modal: Boolean,
  appendToBody: {
    type: Boolean,
    default: false,
  },
  value: String,
})
const emit = defineEmits(['on-cancel', 'update:visible', 'close', 'closed', 'input'])
const { showDrawer, onCancel, handleCancel, close, closed } = useDrawerPack(
  toRef(props, 'visible'),
  emit
)

const keyword = ref('')
const type = ref('pg')
const typeList = shallowRef([
  {
    code: 'pg',
    name: '盘谷图标',
  },
  {
    code: 'omg',
    name: '商城',
  },
  {
    code: 'yj',
    name: '云检',
  },
])

const iconfontList = shallowRef({ glyphs: [] })
const getIconfontList = () => {
  switch (type.value) {
    case 'pg':
      return pgIcons
    case 'omg':
      return omgIcons
    case 'yj':
      return yjIcons
  }
}
const typeChange = () => {
  iconfontList.value = getIconfontList()
}
const searchIconList = computed(() => {
  return iconfontList.value.glyphs?.filter((item) => {
    return item.name.includes(keyword.value)
  })
})
const data = ref(null)
const open = () => {
  type.value = 'pg'
  data.value = props.value
  iconfontList.value = getIconfontList()
}
const select = (item) => {
  data.value = iconfontList.value.css_prefix_text + item.font_class
}
const copy = async (item) => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(iconfontList.value.css_prefix_text + item.font_class)
  } else {
    const inputDom = document.createElement('input')
    inputDom.value = iconfontList.value.css_prefix_text + item.font_class
    document.body.appendChild(inputDom)
    inputDom.select()
    document.execCommand('copy')
    inputDom.remove()
  }
  pgMessage.success('已复制!')
}

const handleOk = () => {
  emit('input', data.value)
  handleCancel()
}
const onClear = () => {
  emit('input', null)
}
</script>
<style lang="scss">
@import '../style/dialog-select-icon.scss';
</style>
